import Amplify, { Auth, Hub, Cache } from 'aws-amplify';
import React, { useState, Component } from 'react';
import {
    StyleSheet,
    View,
    Image,
    Animated,
    AsyncStorage,
    ActivityIndicator,
} from 'react-native';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ThemeProvider } from 'styled-components/native';

import SFDC from './containers/SFDC';

import { authUser } from './appRedux/actions/Auth';
import Menu from './components/Menu';
import PageLoading from './components/PageLoading';
import { PrivateRoute } from './components/PrivateRoute';
import Header from './components/header';
import Login from './containers/Login.jsx';
import config from './containers/amplify-config';
import Routes from './navigation/Routes';
import { Router, Route, Switch, Redirect, Link } from './navigation/router';
import { theme } from './theme/Index';
// function refreshToken() {
//     // refresh the token here and get the new token infohttp://localhost:19006/#access_token=eyJraWQiOiI2d1wvR0xsWDBuUDBtVVFqSUxHSjhYdEEzXC9DMUVOZnJScWUrQXJnMktFRzg9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIzYTA5Mzg0Yi0xYjVmLTQ3ZWQtYjI1NC0wNWM0ZWRhMzlkOGEiLCJjb2duaXRvOmdyb3VwcyI6WyJ1cy1lYXN0LTJfYXgycG5zb1NyX2N1c3RvbWVybW1hc3Rlcm1kbWRldiJdLCJ0b2tlbl91c2UiOiJhY2Nlc3MiLCJzY29wZSI6ImF3cy5jb2duaXRvLnNpZ25pbi51c2VyLmFkbWluIHBob25lIG9wZW5pZCBwcm9maWxlIGVtYWlsIiwiYXV0aF90aW1lIjoxNTg4MTcwMzYwLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0yLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMl9heDJwbnNvU3IiLCJleHAiOjE1ODgxNzM5NjAsImlhdCI6MTU4ODE3MDM2MCwidmVyc2lvbiI6MiwianRpIjoiZWU5ODhjNzEtYmIyMi00NDhlLWEwNTMtNDEyN2EzNTgzOTYwIiwiY2xpZW50X2lkIjoiMm41OW1sdGZ1cm9pbGplbDQ5cGpvdW5tdGQiLCJ1c2VybmFtZSI6ImN1c3RvbWVybW1hc3Rlcm1kbWRldl9BYmR1bGxhaGkuTWFoYW1lZEBWeWFpcmUuY29tIn0.N5spO29Is3uvMcJHmxOJtU0WNsajlx5E0Cs7uyd2T2LWQl_ysy7Ztrg5xDr_d8uoni_Cyv67BopMd1Xb-1Q-9nR07UD3gCR73y3nvUAygB548Cd8JSyHsKRgQf_LzzlKHu8Nd3lWxZfAhWgGmy_i85mxSmsv3wM7m83HfD62uo7kD9XYlxIdkaLGiEQNkz8FecxHyhf0UitnfhMD6vNfOJmilwfBBWWpbHZ9qamkBC3VW6RyqQCbHD-BKp1tLyXgY4zUYqQvVYmW-ZC9enu8T5ogEaV_QRa-ghHSimFJWZzuyiPIK_pN5RRr6r-bNXZaD-k63vN14JzEQ3qAqbkKCg&id_token=eyJraWQiOiJcL0FlUjBPNHR3SU8xU1V2bHEyUjdDa2UxajJsSEltTmRJZFJMUVUyelwvdHM9IiwiYWxnIjoiUlMyNTYifQ.eyJhdF9oYXNoIjoieGpRaVFYLXU1OTVsOXcyaHRfaXN6ZyIsInN1YiI6IjNhMDkzODRiLTFiNWYtNDdlZC1iMjU0LTA1YzRlZGEzOWQ4YSIsImNvZ25pdG86Z3JvdXBzIjpbInVzLWVhc3QtMl9heDJwbnNvU3JfY3VzdG9tZXJtbWFzdGVybWRtZGV2Il0sImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMi5hbWF6b25hd3MuY29tXC91cy1lYXN0LTJfYXgycG5zb1NyIiwiY29nbml0bzp1c2VybmFtZSI6ImN1c3RvbWVybW1hc3Rlcm1kbWRldl9BYmR1bGxhaGkuTWFoYW1lZEBWeWFpcmUuY29tIiwiZ2l2ZW5fbmFtZSI6IkFiZHVsbGFoaSIsImN1c3RvbTp1c2VyZ3JvdXBzIjoiWzdjNTU3NTE2LTJkZmMtNDlhNi1hM2Q0LWZhZTc0NzNkYjY3MywgOWE2MGYyZTAtN2EyYi00MDNmLWFmYTUtZTEwMjY1NDY5ODFiLCA5OTVlNGNjYS0wZWMxLTQwMmUtYjQxMC0wMDcwMGZlMzM4YjgsIDkwMGY3NTM3LWUyYWEtNGZiZi04MDczLWYyZGFjYTg4N2VjYSwgMjE1MzY4ZDMtMjFiYi00YjI0LWFiYjYtZWM5YTZhZWMzOTJjLCAwYWE3MTQ0MS1lZjdhLTRmYjAtOTM4YS00ZjQwZDJhNjZkMzksIGI0ZjhhNTNiLWI5NGMtNDBiMi1hNjQzLWQ1N2EwNjJlNzlmZSwgY2I0NTUxNTMtMmRiOC00ZjZlLTk4ODItOWNkMjE5N2ZmNGE0LCBhMzRlYWEzYy1iYTEwLTQ2ZjAtYThiNS02ZjQ3OGM1ZDljOGUsIDE3NzJlMmIyLTdhNjYtNDhlMC05ODUwLTJlZDYwNTg3Nzc0NSwgOTE4NjdhOTUtNWM0OC00OTIxLWI3NWEtOTlmNmY5Mjc1NjkwLCBkM2Q3ZDJmZi0wYmRkLTRjMjMtYjVhYi02ODAwODU3ZTU0OGNdIiwiY3VzdG9tOnN1cm5hbWUiOiJNYWhhbWVkIiwiYXVkIjoiMm41OW1sdGZ1cm9pbGplbDQ5cGpvdW5tdGQiLCJpZGVudGl0aWVzIjpbeyJ1c2VySWQiOiJBYmR1bGxhaGkuTWFoYW1lZEBWeWFpcmUuY29tIiwicHJvdmlkZXJOYW1lIjoiY3VzdG9tZXJtbWFzdGVybWRtZGV2IiwicHJvdmlkZXJUeXBlIjoiU0FNTCIsImlzc3VlciI6Imh0dHBzOlwvXC9zdHMud2luZG93cy5uZXRcLzY3Y2Y0YWQ0LTZhMWEtNGEwMS05ZGZlLWFmOTRjMWFkYmMwN1wvIiwicHJpbWFyeSI6InRydWUiLCJkYXRlQ3JlYXRlZCI6IjE1ODA4MjYzNDA3NTUifV0sInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNTg4MTcwMzYwLCJuYW1lIjoiQWJkdWxsYWhpLk1haGFtZWRAVnlhaXJlLmNvbSIsImV4cCI6MTU4ODE3Mzk2MCwiaWF0IjoxNTg4MTcwMzYwLCJlbWFpbCI6IkFiZHVsbGFoaS5NYWhhbWVkQHZ5YWlyZS5jb20ifQ.kXEiR1TF2dV4WmyXZLXGxvNsIkAb0MKVPSLFvP4HFrHxa-TyY-NKJ2vZ4_C4GQbZ9SRms6JWnjdgP6SA1pJeOvwH9tKFIFmDoovulBHVtPwffIl65E8iLOeDxPx-3FBmyPTYv2_GDCNh3rzlDkhd8XM91ig6QgOJYBX9ZuzbZgsFfaxuY0GQSFrJDJMh5oL_Bhr7tOQvfJfLoCGWJUNY2Id8aQqHVBYKL75vczF20bv3OBwhTYJAfJNyof-bzHzDEQutFWBI5LaDoC0xHf81Pzh4WnYDZvwR-rwAnJeMkcivl2MC8CH1LMYfe4wx65Jt5jVGSgezeUHrPhzBQcUhJg&state=2DpwfIvAC1SihbvnEZH5HEV7AgD84Mas&token_type=Bearer&expires_in=3600
//     // ......
//
//     console.log('Refreshing');
//
//     return 'TEST';
// }

Amplify.configure(config);

// Auth.configure({
//     refreshHandlers: {
//         customermmastermdmdev: refreshToken, // the property could be 'google', 'facebook', 'amazon', 'developer', OpenId domain
//     },
// });
const ProppedRoute = ({ render: C, props: childProps, ...rest }) => (
    <Route {...rest} render={(rProps) => <C {...rProps} {...childProps} />} />
);

export const MenuContext = React.createContext({
    isToggled: false,
    toggleMenu: () => {},
});

class App extends Component {
    toggle = (value = null) => {
        const isBoolean = value && typeof value === 'boolean';
        this.setState((state) => ({
            isToggled: isBoolean ? value : !state.isToggled,
        }));
    };

    constructor(props) {
        super(props);

        this.toggleMenu = () => {
            this.setState((state) => ({
                isToggled: !state.isToggled,
            }));
        };

        this.state = {
            isToggled: false,
            toggleMenu: this.toggle,
            redirect: false,
        };
    }

    componentDidMount() {
        const params = window.location.pathname;

        const search = window.location.search;

        const localCheck = localStorage.getItem('SFDCData');

        if (params.includes('/sfdc%3F') || search.includes('/sfdc%3F')) {
            const requestData =
                search.length > 0
                    ? search.substr(search.indexOf('sfdc%3F') + 7)
                    : params.substr(params.indexOf('sfdc%3F') + 7);

            const decoded = atob(requestData);

            const queryParams = decoded
                .split('&')
                .reduce((accumulator, singleQueryParam) => {
                    const [key, value] = singleQueryParam.split('=');
                    let newValue = value.replaceAll('+', '%20');
                    accumulator[key] = decodeURIComponent(newValue);
                    return accumulator;
                }, {});

            localStorage.setItem('SFDCData', JSON.stringify(queryParams));

            this.setState({
                redirect: true,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.location !== prevProps.location &&
            this.state.isToggled === true &&
            this.props.location.pathname !== '/search'
        ) {
            this.toggle(false);
        }
    }

    render() {
        const { isToggled, redirect } = this.state;
        const { match } = this.props;
        return (
            <View style={styles.container}>
                <MenuContext.Provider value={this.state}>
                    <View style={{ zIndex: 3 }}>
                        <Header
                            onMenuIconPress={() => this.toggle(!isToggled)}
                            style={{ position: 'absolute', zIndex: 1 }}
                            currentUser={this.props.currentUser}
                            onLogout={() => {
                                Auth.signOut()
                                    .then(async () => {
                                        await AsyncStorage.clear();
                                    })
                                    .catch((err) => console.log(err));
                            }}
                        />
                    </View>
                    <View style={{ zIndex: 1, height: '100vh' }}>
                        <Menu
                            style={{ position: 'absolute', zIndex: 1 }}
                            isToggled={isToggled}
                        />
                        <Routes match={match} />
                        {redirect ? <Redirect to="/sfdc" /> : null}
                    </View>
                </MenuContext.Provider>
            </View>
        );
    }
}

const MainRoutes = ({ childProps }) => (
    <Switch>
        <ProppedRoute exact path="/login" render={Login} props={childProps} />
        <PrivateRoute path="/" render={App} props={childProps} />
    </Switch>
);

class Root extends React.Component {
    constructor(props) {
        super(props);

        Hub.listen('auth', (data) => {
            const { payload } = data;

            if (data.payload.event === 'signIn') {
                this.props.authUser();
                console.log('-----signi---');
            }
        });

        this.state = {
            fontLoaded: false,
            redirect: false,
        };

        this._bootstrapAsync();
    }

    // eslint-disable-next-line no-underscore-dangle
    async _bootstrapAsync() {
        // this.props.authUser();
        try {
            // const currentUser = await Auth.currentAuthenticatedUser();
            // console.log('User already authenticated:', currentUser);
            const federatedInfo = await Cache.getItem('federatedInfo');
            this.props.authUser(); // Set Redux state
            return;
        } catch (error) {
            console.log('User not signed in, checking for Cognito redirect...');

            const urlParams = new URLSearchParams(window.location.search);
            const authCode = urlParams.get('code'); // OAuth2 auth code

            if (authCode) {
                console.log('Processing Cognito authorization code...');
                await Auth.federatedSignIn(); // Exchanges auth code for tokens
                this.props.authUser();
                return;
            }

            console.log('No auth code found, not redirecting to Cognito.');
        }
    }

    async componentDidMount() {
        await Image.prefetch(require('../assets/icons/custom-master.jpeg'));
        await Image.prefetch(require('../assets/icons/vendor-master.jpeg'));
        await Image.prefetch(require('../assets/icons/material-master.jpeg'));

        setTimeout(() => {
            this.setState({ fontLoaded: true });
        }, 850);

        const params = window.location.pathname;

        const search = window.location.search;

        const localCheck = localStorage.getItem('SFDCData');

        if (
            (params.includes('/sfdc%3F') || search.includes('/sfdc%3F')) &&
            localCheck == null
        ) {
            const requestData =
                search.length > 0
                    ? search.substr(search.indexOf('sfdc%3F') + 7)
                    : params.substr(params.indexOf('sfdc%3F') + 7);

            const decoded = atob(requestData);

            const queryParams = decoded
                .split('&')
                .reduce((accumulator, singleQueryParam) => {
                    const [key, value] = singleQueryParam.split('=');
                    let newValue = value.replaceAll('+', '%20');
                    accumulator[key] = decodeURIComponent(newValue);
                    return accumulator;
                }, {});

            localStorage.setItem('SFDCData', JSON.stringify(queryParams));

            this.setState({
                redirect: true,
            });
        }
    }

    render() {
        const { loggedIn, loading } = this.props;
        const { redirect } = this.state;

        const childProps = {
            isLoggedIn: loggedIn,
            onUserSignIn: this.props.authUser,
            currentUser: this.props.user,
            loading: this.props.loading,
        };

        if (!this.state.fontLoaded) return <PageLoading />;

        if (loading === true || loggedIn === null) {
            return (
                <View
                    style={{
                        flex: 1,
                        flexBasis: 'auto',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <ActivityIndicator />
                </View>
            );
        }

        return (
            <ThemeProvider theme={theme}>
                <Router hashType="noslash">
                    <Route path="/">{!loggedIn && <Redirect to="/login" />}</Route>
                    <MainRoutes childProps={childProps} />
                    {redirect ? <Redirect to="/sfdc" /> : null}
                </Router>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.auth.loggedIn,
        user: state.auth.user,
        loggedOut: state.auth.loggedOut,
    };
};

export default connect(mapStateToProps, {
    authUser,
})(Root);

// export default Root;

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
